// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2341":"7f003ffa","3593":"0153b3ee","4749":"eacfa457","9189":"4878a26d"}[chunkId] + ".chunk.css";
};